<template>
  <div style="background: #fff; padding: 30px;">
    <div style="width: 500px; margin: 0 auto 60px">
      <a-steps :current="state.step - 1">
        <a-step title="基础配置" />
        <a-step title="规则配置" />
        <a-step title="素材配置" />
      </a-steps>
    </div>
    <a-form
      layout="horizontal"
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 16 }"
    >
      <Step1 v-if="state.step === 1" />
      <Step2 v-if="state.step === 2" />
      <Step3 v-if="state.step === 3" />
    </a-form>
  </div>
</template>

<script setup>
import { reactive, ref, provide, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import dayjs from 'dayjs'
import { common_lang_get } from '@/server/modules/3426'
import {
  popupWindow_base_popupStyleList,
  popupWindow_base_effectivePageList,
  popupWindow_base_popupTypeList,
  popupWindow_rule_detail,
  popupWindow_base_behaviorConditionList,
  popupWindow_rule_add,
  popupWindow_rule_edit
} from '@/server/modules/51648'
import { theme_query_get } from '@/server/modules/11297'
import Step1 from './components/Step1.vue'
import Step2 from './components/Step2.vue'
import Step3 from './components/Step3.vue'
import { message } from 'ant-design-vue'

const route = useRoute()
const router = useRouter()

const formRef = ref()

const state = reactive({
  step: 1,
  langList: [],
  defaultLanguageCode: '',
  themeTypes: [],
  themeType: null,
  currentLang: '',
  defaultCurrency: '',
  brandId: 1,
  channelId: 1,
  siteId: 1,
  terminalId: 1,
  subTerminalId: 1,
  editable: !route.query.id,
  popupStyleList: [],
  effectivePageList: [],
  popupTypeList: [],
  conditionList: [],

  name: '',
  allSitePage: 0,
  autoFloatingType: null,
  autoPopupType: null,
  description: '',
  startDatetime: '',
  endDatetime: '',
  enable: 0,
  longTerm: 0,
  triggerFrequency: null,
  triggerTime: null,
  popupCount: 1,
  intervalDays: null,
  priority: null,
  type: null,
  specifyPages: [],
  ruleConditions: [],
  ruleMaterials: [],
  effectivePageIds: [],
  style: null,
  personGroup: null,
  personGroupId: null,

  next: () => {
    if (state.step < 3) {
      state.step += 1
    } else {
      state.save()
    }
  },
  prev: () => {
    state.step -= 1
  },
  save: async () => {
    const params = {
      brandId: state.brandId,
      channelId: state.channelId,
      terminalId: state.terminalId,
      siteId: state.siteId,
      allSitePage: state.allSitePage ?? 0,
      autoFloatingType: state.autoFloatingType,
      autoPopupType: state.autoPopupType,
      description: state.description,
      effectivePageIds: state.effectivePageIds,
      enable: state.enable ?? 0,
      endDatetime:
        state.endDatetime === null
          ? state.endDatetime
          : dayjs(state.endDatetime).format('YYYY-MM-DD HH:mm:ss'),
      intervalDays: state.intervalDays,
      longTerm: state.longTerm ?? 0,
      name: state.name,
      personGroup: state.personGroup,
      personGroupId: state.personGroupId,
      priority: state.priority,
      ruleConditions: state.ruleConditions,
      ruleMaterials: state.ruleMaterials.map(i => ({
        ...i,
        relatedRewardsEnable: i.relatedRewardsEnable ?? 0,
        countdownEnable: i.countdownEnable ?? 0,
        ...(i.endTime
          ? { endTime: dayjs(i.endTime).format('YYYY-MM-DD HH:mm:ss') }
          : {})
      })),
      specifyPages: state.specifyPages,
      startDatetime: dayjs(state.startDatetime).format('YYYY-MM-DD HH:mm:ss'),
      style: state.style,
      type: state.type,
      triggerFrequency: state.triggerFrequency,
      triggerTime: state.triggerTime,
      popupCount: state.popupCount
    }
    let api = popupWindow_rule_add
    if (route.query.id) {
      params.id = route.query.id
      api = popupWindow_rule_edit
    }
    const { success, retInfo } = await api(params)
    if (success) {
      message.success('保存成功')
      router.push({
        path: '/PopupRuleList',
        query: {
          uniqueId: route.query.uniqueId,
          siteId: state.siteId,
          terminalId: state.terminalId
        }
      })
    } else {
      message.error(retInfo)
    }
  },
  addCondition: () => {
    if (!state.editable) {
      return
    }
    state.ruleConditions.push({
      conditionKey: null,
      conditionOperationSymbols: null,
      conditionValue: null,
      conditionValueType: null,
      conjunction: 0
    })
  },
  removeCondition: index => {
    if (!state.editable) {
      return
    }
    state.ruleConditions.splice(index, 1)
  },
  changeConjunction: index => {
    if (!state.editable) {
      return
    }
    state.ruleConditions[index].conjunction =
      state.ruleConditions[index].conjunction === 0 ? 1 : 0
  },
  removeSpecifyPage: index => {
    state.specifyPages.splice(index, 1)
  },
  createMeterials: popType => {
    let arr = []
    // popType  8 切tab弹窗
    if (state.terminalId === 2) {
      arr =
        popType !== 8
          ? [
              {
                subTerminalId: null,
                activityEvent: null,
                autoCloseDuration: null,
                countdownDuration: null,
                countdownEnable: null,
                linkUrl: null,
                themeType: null,
                relatedRewardsEnable: null,
                backgroundColor: '#FFF2D7FF', // 默认值
                buttonBackgroundColor: '#C2200CFF', // 默认值
                buttonTextColor: '#FFFFFFFF', // 默认值
                countdownBackgroundColor: '#FFFFFFFF', // 默认值
                countdownFontColor: '#FFFFFFFF', // 默认值
                countdownTitleColor: '#FFFFFFFF', // 默认值
                titleColor: '#C2200CFF',
                endTime: null,
                langs: state.langList.map(i => ({
                  title: null,
                  buttonText: null,
                  countdownTitle: null,
                  bigImageSrc: null,
                  buttonCopywriting: null,
                  copyCopywriting: null,
                  copywriting: null,
                  smallImageSrc: null,
                  langCode: i.value,
                  benefits: null,
                  pushDescription: null
                }))
              }
            ]
          : state.themeTypes.map(themeType => {
              return {
                subTerminalId: null,
                activityEvent: null,
                autoCloseDuration: null,
                countdownDuration: null,
                countdownEnable: null,
                linkUrl: null,
                themeType: themeType.value,
                relatedRewardsEnable: null,
                backgroundColor: '#FFF2D7FF', // 默认值
                buttonBackgroundColor: '#C2200CFF', // 默认值
                buttonTextColor: '#FFFFFFFF', // 默认值
                countdownBackgroundColor: '#FFFFFFFF', // 默认值
                countdownFontColor: '#FFFFFFFF', // 默认值
                countdownTitleColor: '#FFFFFFFF', // 默认值
                titleColor: '#C2200CFF',
                endTime: null,
                langs: state.langList.map(i => ({
                  title: null,
                  buttonText: null,
                  countdownTitle: null,
                  bigImageSrc: null,
                  buttonCopywriting: null,
                  copyCopywriting: null,
                  copywriting: null,
                  smallImageSrc: null,
                  langCode: i.value,
                  benefits: null,
                  pushDescription: null
                }))
              }
            })
    } else {
      if (popType !== 8) {
        arr = [
          {
            subTerminalId: 1,
            activityEvent: null,
            autoCloseDuration: null,
            countdownDuration: null,
            countdownEnable: null,
            linkUrl: null,
            themeType: null,
            relatedRewardsEnable: null,
            backgroundColor: '#FFF2D7FF', // 默认值
            buttonBackgroundColor: '#C2200CFF', // 默认值
            buttonTextColor: '#FFFFFFFF', // 默认值
            countdownBackgroundColor: '#FFFFFFFF', // 默认值
            countdownFontColor: '#FFFFFFFF', // 默认值
            countdownTitleColor: '#FFFFFFFF', // 默认值
            titleColor: '#C2200CFF',
            endTime: null,
            langs: state.langList.map(i => ({
              title: null,
              buttonText: null,
              countdownTitle: null,
              bigImageSrc: null,
              buttonCopywriting: null,
              copyCopywriting: null,
              copywriting: null,
              smallImageSrc: null,
              langCode: i.value,
              benefits: null,
              pushDescription: null
            }))
          },
          {
            subTerminalId: 2,
            activityEvent: null,
            autoCloseDuration: null,
            countdownDuration: null,
            countdownEnable: null,
            linkUrl: null,
            themeType: null,
            relatedRewardsEnable: null,
            backgroundColor: '#FFF2D7FF', // 默认值
            buttonBackgroundColor: '#C2200CFF', // 默认值
            buttonTextColor: '#FFFFFFFF', // 默认值
            countdownBackgroundColor: '#FFFFFFFF', // 默认值
            countdownFontColor: '#FFFFFFFF', // 默认值
            countdownTitleColor: '#FFFFFFFF', // 默认值
            titleColor: '#C2200CFF',
            endTime: null,
            langs: state.langList.map(i => ({
              title: null,
              buttonText: null,
              countdownTitle: null,
              bigImageSrc: null,
              buttonCopywriting: null,
              copyCopywriting: null,
              copywriting: null,
              smallImageSrc: null,
              langCode: i.value,
              benefits: null,
              pushDescription: null
            }))
          }
        ]
      } else {
        state.themeTypes.map(themeType => {
          arr = arr.concat([
            {
              subTerminalId: 1,
              activityEvent: null,
              autoCloseDuration: null,
              countdownDuration: null,
              countdownEnable: null,
              linkUrl: null,
              themeType: themeType.value,
              relatedRewardsEnable: null,
              backgroundColor: '#FFF2D7FF', // 默认值
              buttonBackgroundColor: '#C2200CFF', // 默认值
              buttonTextColor: '#FFFFFFFF', // 默认值
              countdownBackgroundColor: '#FFFFFFFF', // 默认值
              countdownFontColor: '#FFFFFFFF', // 默认值
              countdownTitleColor: '#FFFFFFFF', // 默认值
              titleColor: '#C2200CFF',
              endTime: null,
              langs: state.langList.map(i => ({
                title: null,
                buttonText: null,
                countdownTitle: null,
                bigImageSrc: null,
                buttonCopywriting: null,
                copyCopywriting: null,
                copywriting: null,
                smallImageSrc: null,
                langCode: i.value,
                benefits: null,
                pushDescription: null
              }))
            },
            {
              subTerminalId: 2,
              activityEvent: null,
              autoCloseDuration: null,
              countdownDuration: null,
              countdownEnable: null,
              linkUrl: null,
              themeType: themeType.value,
              relatedRewardsEnable: null,
              backgroundColor: '#FFF2D7FF', // 默认值
              buttonBackgroundColor: '#C2200CFF', // 默认值
              buttonTextColor: '#FFFFFFFF', // 默认值
              countdownBackgroundColor: '#FFFFFFFF', // 默认值
              countdownFontColor: '#FFFFFFFF', // 默认值
              countdownTitleColor: '#FFFFFFFF', // 默认值
              titleColor: '#C2200CFF',
              endTime: null,
              langs: state.langList.map(i => ({
                title: null,
                buttonText: null,
                countdownTitle: null,
                bigImageSrc: null,
                buttonCopywriting: null,
                copyCopywriting: null,
                copywriting: null,
                smallImageSrc: null,
                langCode: i.value,
                benefits: null,
                pushDescription: null
              }))
            }
          ])
        })
      }
    }
    state.ruleMaterials = arr
  }
})
const getTheme = async () => {
  const params = {
    brandId: state.brandId,
    channelId: state.channelId,
    siteId: state.siteId,
    terminalId: state.terminalId
  }
  const { success, data } = await theme_query_get(params)
  if (success) {
    state.themeTypes = data.themeConfigList.map(i => ({
      label: i.themeType,
      value: i.themeType
    }))
    state.themeType = state.themeTypes[0].value
  }
}

const getSiteLang = async () => {
  const { data } = await common_lang_get(route.query)
  state.langList = Object.entries(data.languageMap).map(([key, value]) => ({
    label: key,
    value: value
  }))
  state.defaultLanguageCode = data.defaultLanguageCode
  state.currentLang = data.defaultLanguageCode
  state.defaultCurrency = data.defaultCurrency
  state.terminalId = data.terminalId
  state.brandId = data.brandId
  state.channelId = data.channelId
  state.siteId = data.siteId
  state.site = data
  state.subTerminalId = data.terminalId === 2 ? null : 1
  state.createMeterials(data.terminalId)
}

const getPopupStyleList = async () => {
  const params = {
    brandId: state.brandId,
    channelId: state.channelId,
    siteId: state.siteId,
    terminalId: state.terminalId
  }
  const { data } = await popupWindow_base_popupStyleList(params)
  state.popupStyleList = data
}

const getPopupDetail = async () => {
  const { id } = route.query
  if (id) {
    const { data } = await popupWindow_rule_detail({ id })
    state.allSitePage = data.allSitePage
    state.autoFloatingType = data.autoFloatingType
    state.autoPopupType = data.autoPopupType
    state.description = data.description
    state.effectivePageIds = data.effectivePageIds
    state.enable = data.enable
    state.endDatetime = data.endDatetime ? dayjs(data.endDatetime) : null
    state.intervalDays = data.intervalDays
    // state.popupCount = data.popupCount
    state.longTerm = data.longTerm
    state.name = data.name
    state.personGroup = data.personGroup
    state.personGroupId = data.personGroupId
    state.priority = data.priority
    state.ruleConditions = data.ruleConditions
    state.ruleMaterials = data.ruleMaterials
    state.themeTypes = state.themeTypes.filter(n =>
      data.ruleMaterials.find(item => item.themeType === n.value)
    )
    state.themeType = state.themeTypes[0]?.value
    state.specifyPages = data.specifyPages
    state.startDatetime = dayjs(data.startDatetime)
    state.style = data.style
    state.type = data.type
    state.triggerFrequency = data.triggerFrequency
    state.triggerTime = data.triggerTime
    for (const lang of state.langList) {
      for (const ruleMaterial of state.ruleMaterials) {
        if (ruleMaterial.endTime) {
          ruleMaterial.endTime = dayjs(ruleMaterial.endTime)
        }
        if (!ruleMaterial.langs.some(i => i.langCode === lang.value)) {
          ruleMaterial.langs.push({
            title: null,
            buttonText: null,
            countdownTitle: null,
            bigImageSrc: null,
            buttonCopywriting: null,
            copyCopywriting: null,
            copywriting: null,
            smallImageSrc: null,
            langCode: lang.value,
            benefits: null
          })
        }
      }
    }
  }
}

const getConditionList = async () => {
  const params = {
    brandId: state.brandId,
    channelId: state.channelId,
    siteId: state.siteId,
    terminalId: state.terminalId
  }
  const { data } = await popupWindow_base_behaviorConditionList(params)
  state.conditionList = data
}

const getPopupTypeList = async () => {
  const params = {
    brandId: state.brandId,
    channelId: state.channelId,
    siteId: state.siteId,
    terminalId: state.terminalId
  }
  const { data } = await popupWindow_base_popupTypeList(params)
  state.popupTypeList = data
}

const getEffectivePageList = async () => {
  const params = {
    brandId: state.brandId,
    channelId: state.channelId,
    siteId: state.siteId,
    terminalId: state.terminalId
  }
  const { data } = await popupWindow_base_effectivePageList(params)
  state.effectivePageList = data
}

provide('formRef', formRef)
provide('initState', state)

onMounted(async () => {
  await getSiteLang()
  await getTheme()
  await getPopupStyleList()
  await getEffectivePageList()
  await getPopupTypeList()
  await getConditionList()
  getPopupDetail()
})
</script>
